import { type Masked, unmask } from '~/contentful/graphql';
import { AnalyticsCard, AnalyticsContent } from '~/ui/components/analytics';
import { BaseCard, CardSize, type CommonCardProps } from '~/ui/components/cards/base';
import { getInternalLinkFromFragment } from '~/ui/systems/internalLink';

import { type GrantStoryCard_GrantActivityArticleFragment } from './query';

export interface GrantStoryCardProps extends CommonCardProps {
  data: Masked<typeof GrantStoryCard_GrantActivityArticleFragment>;
  size?: CardSize;
}

export function GrantStoryCard({
  data,
  module,
  size = CardSize.DEFAULT,
  ...props
}: GrantStoryCardProps) {
  const grantStory = unmask<typeof GrantStoryCard_GrantActivityArticleFragment>(data);

  return (
    <BaseCard
      eyebrow={grantStory.granteeNameOverride ?? grantStory.grant?.organization?.name ?? undefined}
      title={grantStory.title ?? ''}
      hero={grantStory.hero ?? grantStory.leadImage ?? undefined}
      cta="Read the grant story"
      href={getInternalLinkFromFragment(grantStory)}
      size={size}
      event={{
        cardType: AnalyticsCard.ARTICLE,
        cardContentType: AnalyticsContent.GRANT_STORY,
        cardModule: module,
      }}
      truncateTitle={3}
      {...props}
    />
  );
}
